// eslint-disable-next-line
export const ACTION_PREFIX = 'app/';
export const SITE_URL = window.siteUrl;
export const SCREEN_ID = window.screenId;
export const PRIORITY = window.priority;



// WEBPACK FOOTER //
// ./src/strings.js